import React from 'react'
import PropTypes from 'prop-types'

import './ApiLoader.scss'

import NgineApiLoader from '../NgineApiLoader/NgineApiLoader'
import Spinner from '../Spinner/Spinner'
import clientLogin from '../../../shared/clientLogin'

function ApiLoader({ branding = null, loading = false }) {
  const clientId = localStorage.getItem('clientId')
  return (branding && branding.NAME === 'ngine') ||
    (clientId && clientId === clientLogin.ADMIN) ? (
    <NgineApiLoader isLoading={loading} />
  ) : (
    loading && (
      <div className="client-api-loader">
        <Spinner />
      </div>
    )
  )
}

ApiLoader.propType = {
  branding: PropTypes.object,
  loading: PropTypes.bool,
}

export default ApiLoader
